import React from 'react'
import {
  Switch, Route,
} from "react-router-dom";
import Login from './components/Login/Login'
import DigitalFarm from './components/DigitalFarm/DigitalFarm'
import Environment from './components/Environment/Environment'
import CultivationReport from './components/CultivationReport/CultivationReport'
import CultivationRecords from './components/CultivationRecords/CultivationRecords'
import HarvestReport from './components/HarvestReport/HarvestReport'
import CultivationModel from './components/CultivationModels/CultivationModels'
import Irrigation from './components/Irrigation/Irrigation'

const Routes = () => (
    <Switch>
            <Route exact path="/" component={DigitalFarm}/>
            <Route path="/login" component={Login}/>
            <Route path="/digital_farm" component={DigitalFarm}/>
            <Route path="/environment" component={Environment}/>
            <Route path="/cultivation_report" component={CultivationReport}/>
            <Route path="/cultivation_records" component={CultivationRecords}/>
            <Route path="/harvest_report" component={HarvestReport}/>
            <Route path="/cultivation_models" component={CultivationModel}/>
            <Route path="/irrigation" component={Irrigation}/>

    </Switch>
);

export default Routes


